import { Badge } from '@mantine/core';
import { CANDIDATE_STATUS_PRESENTATION } from '../../constants';
import type { CandidateStatusCode } from '../../types';
import classes from './CandidateStatusBadge.module.scss';

type CandidateStatusBadgeProps = {
  status?: CandidateStatusCode;
};

export const CandidateStatusBadge = ({ status }: CandidateStatusBadgeProps) => {
  if (!status) {
    return null;
  }

  const presentation = CANDIDATE_STATUS_PRESENTATION[status];

  return (
    <Badge
      className={classes.badge}
      styles={{
        root: { backgroundColor: presentation.backgroundColor },
        label: { color: presentation.color },
      }}
    >
      {presentation.label}
    </Badge>
  );
};
